import { render, staticRenderFns } from "./Severity.vue?vue&type=template&id=1e083043&"
import script from "./Severity.vue?vue&type=script&lang=js&"
export * from "./Severity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports